import { useNavigate, useParams } from "react-router"
import { ReactElement, useRef } from "react";
import topic_icon from 'url:../../assets/cnn/frm/topic.png';
import user_data from './CNNARCH/CNNF-USERS.json';
import board_data from './CNNARCH/CNNF-BOARDS.json';
import topic_data_1 from './CNNARCH/CNNF-TOPIC-1.json';
import topic_data_2 from './CNNARCH/CNNF-TOPIC-2.json';
import topic_data_3 from './CNNARCH/CNNF-TOPIC-3.json';
import topic_data_4 from './CNNARCH/CNNF-TOPIC-4.json';
import topic_data_5 from './CNNARCH/CNNF-TOPIC-5.json';
import topic_data_6 from './CNNARCH/CNNF-TOPIC-6.json';
import topic_data_7 from './CNNARCH/CNNF-TOPIC-7.json';
import topic_data_8 from './CNNARCH/CNNF-TOPIC-8.json';
import topic_data_9 from './CNNARCH/CNNF-TOPIC-9.json';
import topic_data_10 from './CNNARCH/CNNF-TOPIC-10.json';
import topic_data_11 from './CNNARCH/CNNF-TOPIC-11.json';
import topic_data_12 from './CNNARCH/CNNF-TOPIC-12.json';
import topic_data_13 from './CNNARCH/CNNF-TOPIC-13.json';
import topic_data_14 from './CNNARCH/CNNF-TOPIC-14.json';
import topic_data_15 from './CNNARCH/CNNF-TOPIC-15.json';
import topic_data_16 from './CNNARCH/CNNF-TOPIC-16.json';
import topic_data_17 from './CNNARCH/CNNF-TOPIC-17.json';
import topic_data_18 from './CNNARCH/CNNF-TOPIC-18.json';
import topic_data_19 from './CNNARCH/CNNF-TOPIC-19.json';
import topic_data_20 from './CNNARCH/CNNF-TOPIC-20.json';
import topic_data_21 from './CNNARCH/CNNF-TOPIC-21.json';
import topic_data_22 from './CNNARCH/CNNF-TOPIC-22.json';
import topic_data_23 from './CNNARCH/CNNF-TOPIC-23.json';
import topic_data_24 from './CNNARCH/CNNF-TOPIC-24.json';
import topic_data_25 from './CNNARCH/CNNF-TOPIC-25.json';
import topic_data_26 from './CNNARCH/CNNF-TOPIC-26.json';
import topic_data_27 from './CNNARCH/CNNF-TOPIC-27.json';
import topic_data_28 from './CNNARCH/CNNF-TOPIC-28.json';
import topic_data_29 from './CNNARCH/CNNF-TOPIC-29.json';
import topic_data_30 from './CNNARCH/CNNF-TOPIC-30.json';
import topic_data_31 from './CNNARCH/CNNF-TOPIC-31.json';
import topic_data_32 from './CNNARCH/CNNF-TOPIC-32.json';
import topic_data_33 from './CNNARCH/CNNF-TOPIC-33.json';
import topic_data_34 from './CNNARCH/CNNF-TOPIC-34.json';
import topic_data_35 from './CNNARCH/CNNF-TOPIC-35.json';
import topic_data_36 from './CNNARCH/CNNF-TOPIC-36.json';
import topic_data_37 from './CNNARCH/CNNF-TOPIC-37.json';
import topic_data_38 from './CNNARCH/CNNF-TOPIC-38.json';
import topic_data_39 from './CNNARCH/CNNF-TOPIC-39.json';
import topic_data_40 from './CNNARCH/CNNF-TOPIC-40.json';
import topic_data_41 from './CNNARCH/CNNF-TOPIC-41.json';
import topic_data_42 from './CNNARCH/CNNF-TOPIC-42.json';
import topic_data_43 from './CNNARCH/CNNF-TOPIC-43.json';
import Markdown from "react-markdown";
import { GetIcon } from "./CNNICONS";

class BoardData
{
    id: string = '';
    title: string = '';
    description: string = '';
    topics: number = 0;
    posts: number = 0;
}

class TopicData
{
    id: string = '';
    board: string = '';
    title: string = '';
    author: string = '';
    replies: number = 0;
    posts: PostData[] = [];
}

class PostData
{
    user: string = '';
    body: string = '';
    parsedBody : string[] = [];
}

class UserData
{
    id: string = '';
    icon: string = '';
    username: string = '';
    signature: string = '';
}

function ParseTopic(topic : TopicData) : TopicData
{
    topic.posts.forEach(p => {
        p.parsedBody = p.body.split('\n');
    });
    return topic;
}

export function CNNF () {
    const { boardId, topicId } = useParams();

    const boards = useRef<BoardData[]>([]);
    const topics = useRef<TopicData[]>([]);
    const users = useRef<UserData[]>([]);
    try {
        boards.current = board_data as BoardData[];
        users.current = user_data as UserData[];
        topics.current = [];
        topics.current.push(ParseTopic(topic_data_1 as TopicData));
        topics.current.push(ParseTopic(topic_data_2 as TopicData));
        topics.current.push(ParseTopic(topic_data_3 as TopicData));
        topics.current.push(ParseTopic(topic_data_4 as TopicData));
        topics.current.push(ParseTopic(topic_data_5 as TopicData));
        topics.current.push(ParseTopic(topic_data_6 as TopicData));
        topics.current.push(ParseTopic(topic_data_7 as TopicData));
        topics.current.push(ParseTopic(topic_data_8 as TopicData));
        topics.current.push(ParseTopic(topic_data_9 as TopicData));
        topics.current.push(ParseTopic(topic_data_10 as TopicData));
        topics.current.push(ParseTopic(topic_data_11 as TopicData));
        topics.current.push(ParseTopic(topic_data_12 as TopicData));
        topics.current.push(ParseTopic(topic_data_13 as TopicData));
        topics.current.push(ParseTopic(topic_data_14 as TopicData));
        topics.current.push(ParseTopic(topic_data_15 as TopicData));
        topics.current.push(ParseTopic(topic_data_16 as TopicData));
        topics.current.push(ParseTopic(topic_data_17 as TopicData));
        topics.current.push(ParseTopic(topic_data_18 as TopicData));
        topics.current.push(ParseTopic(topic_data_19 as TopicData));
        topics.current.push(ParseTopic(topic_data_20 as TopicData));
        topics.current.push(ParseTopic(topic_data_21 as TopicData));
        topics.current.push(ParseTopic(topic_data_22 as TopicData));
        topics.current.push(ParseTopic(topic_data_23 as TopicData));
        topics.current.push(ParseTopic(topic_data_24 as TopicData));
        topics.current.push(ParseTopic(topic_data_25 as TopicData));
        topics.current.push(ParseTopic(topic_data_26 as TopicData));
        topics.current.push(ParseTopic(topic_data_27 as TopicData));
        topics.current.push(ParseTopic(topic_data_28 as TopicData));
        topics.current.push(ParseTopic(topic_data_29 as TopicData));
        topics.current.push(ParseTopic(topic_data_30 as TopicData));
        topics.current.push(ParseTopic(topic_data_31 as TopicData));
        topics.current.push(ParseTopic(topic_data_32 as TopicData));
        topics.current.push(ParseTopic(topic_data_33 as TopicData));
        topics.current.push(ParseTopic(topic_data_34 as TopicData));
        topics.current.push(ParseTopic(topic_data_35 as TopicData));
        topics.current.push(ParseTopic(topic_data_36 as TopicData));
        topics.current.push(ParseTopic(topic_data_37 as TopicData));
        topics.current.push(ParseTopic(topic_data_38 as TopicData));
        topics.current.push(ParseTopic(topic_data_39 as TopicData));
        topics.current.push(ParseTopic(topic_data_40 as TopicData));
        topics.current.push(ParseTopic(topic_data_41 as TopicData));
        topics.current.push(ParseTopic(topic_data_42 as TopicData));
        topics.current.push(ParseTopic(topic_data_43 as TopicData));

        boards.current.forEach(b => {
            b.topics = 0;
            b.posts = 0;
            topics.current.forEach(t => {
                if (t.board === b.id)
                {
                    b.topics++;
                    b.posts += t.replies ?? 0;
                }
            })
        });
    }
    catch (e) {
        console.error(e);
    }
    
    if (boardId == undefined)
        return null;


    let page !: ReactElement;
    switch (boardId)
    {
        case 'home':
            page = <CNNFH boards={boards.current} />;
            break;
        default:
            const board = boards.current.find(b => b.id == boardId);
            if (board === undefined)
                return null;
            if (topicId !== undefined)
            {
                const topic = topics.current.find(t => t.id == topicId);
                if (topic === undefined)
                    return null;
                page = <CNNForumTopic board={board} topic={topic} users={users.current} />;
            }
            else
            {
                const boardTopics : TopicData[] = [];
                topics.current.forEach(t => {
                    if (t.board == board.id)
                        boardTopics.push(t);
                });
                page = <CNNForumBoard board={board} topics={boardTopics} users={users.current} />;
            }
            break;
    }

    return <div className="v-box gap-32">
        <div className='cnn-outline'>
            <h3 className='cnn-box-header text-24 text-white'>CNN FORUMS</h3>
            <h3 className="cnn-box-header-alt cnn-outline text-white">THE SOURCE OF TRUTH</h3>
        </div>
        { page }
    </div>
}

export function CNNFH (props: { boards: BoardData[] }) {
    return <div className="v-box gap-16 cnn-forum">
        <div className="cnn-path-header cnn-outline h-box align-center">
            <h3 className="text-green width-100p">Forums Home</h3>
        </div>
        <div className="h-box cnn-outline bg-black"> 
            <div className="cnn-forum-box cnn-forum-body">
                Boards
            </div>
            <div className="cnn-forum-box cnn-forum-box-count">
                Topics
            </div>
            <div className="cnn-forum-box cnn-forum-box-count">
                Posts
            </div>
        </div>
        <div className="v-box cnn-outline">
            { props.boards.map((b, i) => <CNNForumBoardButton key={i} board={b} />) }
        </div>
    </div>
}

function CNNForumBoardButton (props: { board: BoardData }) {
    return <div className="h-box bg-black cnn-forum-box-boardline">
        <div className="cnn-forum-box cnn-forum-box-icon">
            <img src={topic_icon} className="width-32 height-32" />
        </div>
        <div className="cnn-forum-box cnn-forum-body">
            <a href={"/cnn/forums/" + props.board.id} className="text-18">{ props.board.title }</a>
            <p className="text-14 text-white">{ props.board.description }</p>
        </div>
        <div className="cnn-forum-box cnn-forum-box-count">
            { props.board.topics }
        </div>
        <div className="cnn-forum-box cnn-forum-box-count">
            { props.board.posts }
        </div>
    </div>
}

function CNNForumBoard(props: { board: BoardData, users: UserData[], topics: TopicData[] }) {
    const nav = useNavigate();
    return <div className="v-box gap-16 cnn-forum">
        <div className="cnn-path-header cnn-outline h-box align-center">
            <button className="bg-black text-white" onClick={() => { nav("/cnn/forums/home"); }}>←</button>
            <h3 className="text-green width-100p">{ props.board.title }</h3>
        </div>

        <div className="h-box cnn-outline bg-black"> 
            <div className="cnn-forum-box cnn-forum-body">
                Topic
            </div>
            <div className="cnn-forum-box cnn-forum-box-count">
                Author
            </div>
            <div className="cnn-forum-box cnn-forum-box-count">
                Replies
            </div>
        </div>

        <div className="v-box cnn-outline">
            {
                props.topics.map((t, i) => {
                    return <CNNForumTopicButton key={i} board={props.board} topic={t} users={props.users} />
                })
            }
        </div>
    </div>
}

function CNNForumTopicButton(props: { board: BoardData, users: UserData[], topic: TopicData }) {
    const author = props.users.find(u => u.id == props.topic.author);
    return <div className="h-box bg-black cnn-forum-box-topicline">
        <div className="cnn-forum-box cnn-forum-body">
            <a href={"/cnn/forums/" + props.board.id + "/" + props.topic.id} className="text-18">{ props.topic.title }</a>
            {/* <p className="text-14 text-white">Board description that tells you something about it</p> */}
        </div>
        <div className="cnn-forum-box cnn-forum-box-count">
            { author !== undefined ? author.username : '' }
        </div>
        <div className="cnn-forum-box cnn-forum-box-count">
            { props.topic.replies }
        </div>
    </div>
}

function CNNForumTopic (props: { board: BoardData, topic: TopicData, users: UserData[] }) {
    const nav = useNavigate();
    return <div className="v-box gap-16 cnn-forum">
        <div className="cnn-path-header cnn-outline h-box align-center">
            <button className="bg-black text-white" onClick={() => { nav("/cnn/forums/" + props.board.id); }}>←</button>
            <h3 className="text-green">{ props.board.title }</h3>
            <p className="text-white">/</p>
            <h3 className="text-green">{ props.topic.title }</h3>
        </div>
        <div className="v-box cnn-outline">
            {
                props.topic.posts.map((p, i) => {
                    return <CNNForumPost key={i} post={p} users={props.users} />;
                })
            }
        </div>
    </div>
}

function CNNForumPost (props: {
    post : PostData,
    users : UserData[]
}) {
    const user = props.users.find(u => u.id == props.post.user);
    if (user === undefined)
        return null;
    return <div className="cnn-outline cnn-forum-post bg-black h-box">
        <div className="cnn-forum-box-user v-box center-all gap-8">
            <div className="text-14 text-center">{ user.username }</div>
            {
                user.icon !== ""
                    ? <img src={GetIcon(user.icon)} className="width-64"></img>
                    : <img src={topic_icon} className="width-64"></img>
            }
        </div>
        <div className="v-box cnn-forum-post-body gap-4">
            <div className="v-box">
            {
                props.post.parsedBody.map((b, i) => {
                    return <Markdown key={i} className="text-14 text-white">{ b }</Markdown>
                })
            }
            </div>
            <hr className="cnn-forum-divider" />
            <div className="text-white text-14">
                <i>{ user.signature }</i>
            </div>
        </div>
    </div>
}